import { IoLogoSass } from 'react-icons/io'

export const SassTech = () => {
    return (
        <div>
        <IoLogoSass />
        <h4>Sass</h4>
        </div>
    )
}